import PropTypes from 'prop-types';
import React, { Component, forwardRef, memo } from 'react';
import { Input } from '~/native-ui/Input';
import { ReadonlyField } from '~/native-ui/Fields/ReadonlyField';

export const TextField = (() => {
    class TextField extends Component {
        static propTypes = {
            isReadonly: PropTypes.bool,
            title: PropTypes.string.isRequired,
            editable: PropTypes.bool.isRequired,
            value: PropTypes.string,
            name: PropTypes.string.isRequired,
        };

        static defaultProps = {
            value: '',
        };

        getValue() {
            let { value, type, trans, isReadonly } = this.props;

            if (isReadonly && type === 'password') {
                value = trans('passwordPlaceholder');
            }

            return value;
        }

        renderReadonly = () => {
            let { value, type, trans } = this.props;

            if (type === 'password') {
                value = trans('passwordPlaceholder');
            }

            return (
                <ReadonlyField
                    className={this.props.className}
                    tooltip={this.props.tooltip}
                    label={this.props.title}
                    value={value}
                />
            );
        };

        handleChange = (value) => {
            this.props.onChange(value);
        };

        render() {
            let { disabled, icon, required, iconLeft, iconRight, iconSize, placeholder, onBlur } = this.props;

            if (this.props.isReadonly) {
                return this.renderReadonly();
            }

            return (
                <Input
                    ref={this.props.forwardedRef}
                    // Meta
                    iconSize={iconSize}
                    iconLeft={iconLeft}
                    iconRight={icon || iconRight}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    value={this.getValue()}
                    variant={this.props.variant}
                    multiline={this.props.multiline}
                    isinvalid={this.props.isinvalid}
                    error={this.props.validationMessage}
                    label={this.props.hideLabel ? '' : this.props.title}
                    tooltip={this.props.tooltip}
                    type={this.props.fieldType ? this.props.fieldType : this.props.type}
                    // Methods
                    onClick={this.props.onClick}
                    onChange={this.handleChange}
                    onMouseEnter={this.props.onMouseEnter}
                    onMouseLeave={this.props.onMouseLeave}
                    onKeyPress={this.props.onKeyPress}
                    onSubmitEditing={this.props.onSubmitEditing}
                    autoComplete={this.props.autoComplete}
                    onBlur={this.props.onBlur}
                />
            );
        }
    }

    return memo(forwardRef((props, ref) => <TextField {...props} forwardedRef={ref} />));
})();
